import { useGetQueryHeroBanner } from 'domains/merchandising/api/hero-banners/getContentHeroBanner.hooks'
import { useRetailerId } from 'utils/routing/params.hooks'

export const useQueryHeroBanner = ({ id }) => {
  const retailerId = useRetailerId()
  const { apiResult, apiSuccess, apiLoading, apiError } = useGetQueryHeroBanner({ id, retailerId })

  return {
    apiResult,
    apiSuccess,
    apiLoading,
    apiError,
  }
}

export type HeroListBannerBehaviour = ReturnType<typeof useQueryHeroBanner>
